
import React, { useState } from 'react';
import { subDays } from 'date-fns';
import { DateRange } from 'react-day-picker';
import { useAnalyticsData } from '@/hooks/useAnalyticsData';
import { useLiveAnalytics } from '@/hooks/useLiveAnalytics';
import AnalyticsHeader from '@/components/admin/analytics/AnalyticsHeader';
import StatCardsGrid from '@/components/admin/analytics/StatCardsGrid';
import LiveActivitySection from '@/components/admin/analytics/LiveActivitySection';
import AudienceCharts from '@/components/admin/analytics/AudienceCharts';
import PerformanceCharts from '@/components/admin/analytics/PerformanceCharts';
import TopLists from '@/components/admin/analytics/TopLists';

const AdminAnalytics = () => {
  const liveData = useLiveAnalytics();
  
  // Set default to last 7 days instead of 30 days for more recent data
  const [dateRange, setDateRange] = useState<DateRange | undefined>({
    from: subDays(new Date(), 7),
    to: new Date(),
  });

  const { data: analytics, isLoading, error } = useAnalyticsData(dateRange);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-red-600">
          <p className="text-lg font-semibold">Error loading analytics</p>
          <p className="text-sm">{error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <AnalyticsHeader dateRange={dateRange} setDateRange={setDateRange} />
      <LiveActivitySection liveData={liveData} />
      <StatCardsGrid analytics={analytics} />
      <AudienceCharts analytics={analytics} />
      <PerformanceCharts analytics={analytics} />
      <TopLists analytics={analytics} />
    </div>
  );
};

export default AdminAnalytics;
